// An offer signature can emit accountsChanged while UniSat unlocks. Keep this
// guard scoped to offer requests; existing listing/purchase behavior is unchanged.
let active = 0
export function offerSigningActive(): boolean {
	return active > 0
}
export function beginOfferSigning(): () => void {
	active++
	let released = false
	return () => {
		if (!released) {
			released = true
			active--
		}
	}
}
